import React, { useState } from 'react';
import { Link } from 'react-router-dom';


const About = () => {
  const [activeTab, setActiveTab] = useState('#tab-1');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      {/* page-title */}
      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg-img.png)` }}></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>About</h1>
            <ul className="bread-crumb clearfix">
              <li><Link to={'/'}>Home</Link></li>
              <li>About</li>
            </ul>
          </div>
        </div>
      </section>
      {/* page-title end */}

      {/* about-section */}
      <section className="about-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image-box">
                <figure className="image"><img src={`${process.env.PUBLIC_URL}/assets/img/ABOUT-US.png`} alt="" /></figure>
                <div className="text">
                  <h5>40+ Years Experienced</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box">
                <div className="sec-title">
                  <span className="sub-title">About Us</span>
                  <h2 style={{ fontSize: '35px', lineHeight: '49px' }}>High Precision High Quality</h2>
                  <h3>We believe in precision</h3>
                </div>
                <div className="text">
                  <p>Since 1983, bearings have been our sole focus at SNKB Bearing Store. With one of Mumbai's largest inventories, we offer over 2000 different items available for shipment, with new arrivals daily. Our dedicated team takes pride in understanding each customer's unique requirements, providing expert technical guidance to identify the best solutions for any application. Strategically located and stocked warehouses ensure prompt delivery, backed by competitive pricing. We offer special price quotations for volume orders and hard-to-find items, making us a preferred source for precision bearings. SNKB serves industries ranging from precision machine tools to national defense, ensuring reliable supply for critical applications.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* about-section end */}

      <section className="chooseus-section">
        <div
          className="pattern-layer"
          style={{ backgroundImage: "url(assets/images/shape/shape-4.png)" }}
        ></div>
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-xl-6 col-lg-12 col-md-12 title-column">
              <div className="sec-title">
                <span className="sub-title">Why Choose Us</span>
                <h2>
                  Your Bearings Expert Since 1983 - Trust SNKB for Quality,
                  Value, and Service
                </h2>
                <p>
                  Since 1983, SNKB has been your trusted bearings expert,
                  delivering unparalleled quality, value, and service. Count on
                  us for precision solutions that stand the test of time
                </p>
                <Link to="#" className="theme-btn btn-two">
                  <span>More Details</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="right-column">
          <div className="scroll-text">
            <ul className="text-list clearfix">
              <li>Your Bearings Expert Since 1983 </li>
              <li>Trust SNKB for Quality, Value, and Services</li>
            </ul>
          </div>
          <div className="content-box">
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">01</span>
                <div className="text">
                  <h3>100% Genuine supply</h3>
                  <p>
                    SNKB Bearing Store guarantees 100% genuine supply, ensuring
                    customers receive authentic products of the highest quality
                    and reliability.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/Genuine-supply.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>100% Genuine supply</h3>
                  <p>
                    SNKB Bearing Store guarantees 100% genuine supply, ensuring
                    customers receive authentic products of the highest quality
                    and reliability.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">02</span>
                <div className="text">
                  <h3>40 Years of expectations</h3>
                  <p>
                    Exceeding expectations for four decades, delivering quality
                    bearings worldwide.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/expectations.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>40 Years of expectations</h3>
                  <p>
                    Exceeding expectations for four decades, delivering quality
                    bearings worldwide.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">03</span>
                <div className="text">
                  <h3>24X7 Services</h3>
                  <p>
                    SNKB Bearing Store provides 24/7 services, ensuring prompt
                    assistance and support to customers around the clock,
                    enhancing reliability and customer satisfaction.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/24-7.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>24X7 Services</h3>
                  <p>
                    SNKB Bearing Store provides 24/7 services, ensuring prompt
                    assistance and support to customers around the clock,
                    enhancing reliability and customer satisfaction.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">04</span>
                <div className="text">
                  <h3>Full Technical support</h3>
                  <p>
                    Comprehensive technical support available for all
                    bearing-related inquiries and requirements.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/technical-support.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>Full Technical support</h3>
                  <p>
                    Comprehensive technical support available for all
                    bearing-related inquiries and requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-text">
            <ul className="text-list clearfix">
              <li>Why Choose SNKB Bearings </li>
              <li>Reliable Performance</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="certification-section sec-pad">
            <div className="auto-container">
                <div className="sec-title centred">
                    <span className="sub-title">Certification</span>
                    <h2>Our Awards & Achievements</h2>
                </div>
                <div className="single-item-carousel ">
                    <div className="content-box">
                        <div className="row clearfix">
                            <div className="col-lg-7 col-md-6 col-sm-12 image-column">
                                <figure className="image image-1">
                                    <img src="assets/img/award.png" style={{ height: '463px' }} alt="" />
                                </figure>
                            </div>
                            <div className="col-lg-5 col-md-6 col-sm-12 image-column">
                                <figure className="image image-2">
                                    <img src="assets/img/his-4.png" style={{ height: '463px' }} alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="industry-section">
      <div className="industry-tab">
        <div className="tab-btns industry-tab-btns centred border-top border-bottom">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-1' ? 'active-btn' : ''}`}
                  data-tab="#tab-1"
                  onClick={() => handleTabClick('#tab-1')}
                >
                  <div className="icon-box"><i className="flaticon-crane"></i></div>
                  <h4>Our mission</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-2' ? 'active-btn' : ''}`}
                  data-tab="#tab-2"
                  onClick={() => handleTabClick('#tab-2')}
                >
                  <div className="icon-box"><i className="flaticon-tanks"></i></div>
                  <h4>Our Vision</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-3' ? 'active-btn' : ''}`}
                  data-tab="#tab-3"
                  onClick={() => handleTabClick('#tab-3')}
                >
                  <div className="icon-box"><i className="flaticon-vaccine"></i></div>
                  <h4>Infrastructure</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-4' ? 'active-btn' : ''}`}
                  data-tab="#tab-4"
                  onClick={() => handleTabClick('#tab-4')}
                >
                  <div className="icon-box"><i className="flaticon-radiator"></i></div>
                  <h4>Core Values</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="auto-container">
      <div className="p-tabs-content">
        <div className={`p-tab ${activeTab === '#tab-1' ? 'active-tab' : ''}`} id="tab-1">
        {/* <div className={`p-tab ${activeTab === '#tab-1' ? 'active-tab' : ''}`} id="tab-1"> */}

          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Our mission</span>
                      <h2>Our mission</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Precision solutions exceeding industry standards</li>
                        <li>Long-term partnerships through exceptional service</li>
                      </ul>
                      <p>Our mission at SNKB Berings is to engineer precision solutions, drive innovation, and exceed customer expectations for seamless industrial operations</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/mision.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-2' ? 'active-tab' : ''}`} id="tab-2">
          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Our Vision</span>
                      <h2>Our Vision</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Innovation, Excellence, and Sustainable Growth</li>
                        <li>Leading Through Innovation and Global Impact</li>
                      </ul>
                      <p>Our vision at SNKB Berings is to pioneer innovative solutions, exceed industry standards, and become a global leader in precision engineering</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/vision.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-3' ? 'active-tab' : ''}`} id="tab-3">
          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Infrastructure</span>
                      <h2>Infrastructure</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Enhancing Efficiency and Reliability</li>
                        <li>Streamlining Operations</li>
                      </ul>
                      <p>Our infrastructure boasts state-of-the-art manufacturing facilities equipped with cutting-edge technology, ensuring precision engineering and consistent quality standards</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/Infrastructure.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-4' ? 'active-tab' : ''}`} id="tab-4">
          <div className="single-item-carousel">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Core Values</span>
                      <h2>Core Values</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Adaptability, Collaboration, Excellence, Innovation</li>
                        <li>Integrity, Sustainability, Teamwork</li>
                      </ul>
                      <p>Our core values of Adaptability, Collaboration, Excellence, Innovation, Integrity, Sustainability, and Teamwork drive our every endeavor for success</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/core-values.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
            .owl-nav.disabled {
              display: none;
            }
          `}
        </style>
      </div>
    </div>
      </div>
    </section>
    </>
  );
}

export default About;
